export default {
  completeShopFirst: {
    description: 'Complete your shop settings before changing your billing method.',
    button: 'Complete Shop Settings',
  },
};
